<!--
 * @Author: zeng_cheng
 * @Date: 2021-04-27 10:53:21
 * @LastEditTime: 2021-06-11 14:30:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cloud_app\src\common\components\Prompt.vue
-->
<template>
  <van-dialog
    v-model="visible"
    :title="title"
    @confirm="submit"
    @closed="remove"
    show-cancel-button
    close-on-popstate
  >
    <div class="inputContainer">
      <input type="text" :placeholder="placehodler" v-model="value" />
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: "message",
  data() {
    return {
      visible: false,
      value: ""
    };
  },
  props: {
    show: {
      type: Boolean
    },
    getValue: {
      type: Function
    },
    beforeClose: {
      type: Function
    },
    remove: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    placehodler: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: [String, Number],
      default: ""
    }
  },
  methods: {
    showModal() {
      this.visible = false;
    },
    submit() {
      this.getValue(this.value);
    }
  },
  mounted() {
    this.visible = true;
    this.value = this.defaultValue || "";
  }
};
</script>

<style scoped lang="scss">
.inputContainer {
  padding: 35px;
  width: 100%;
  margin-bottom: 45px;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  input {
    box-sizing: border-box;
    display: block;
    width: 81%;
    height: 80px;
    padding: 0 30px;
    background-color: #f5f5f5;
    border-radius: 8px;
    border: solid 1px #dddddd;
    font-family: MicrosoftYaHei;
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
  }
}
</style>
